/* Corporate sidebar accordion.
   Delegated from document, because the corporate pages re-render their
   sections on navigation and listeners bound at load would be discarded. */
(function () {
  if (window.__ybnCorpNav) return;
  window.__ybnCorpNav = true;

  document.addEventListener('click', function (e) {
    var head = e.target.closest ? e.target.closest('.ybn-corpnav__head') : null;
    if (!head) return;
    if (head.tagName !== 'BUTTON') return; // plain rows are real links

    var group = head.parentNode;
    if (!group || group.className.indexOf('ybn-corpnav__group') === -1) return;

    var open = group.className.indexOf('is-open') !== -1;
    if (open) {
      group.className = group.className.replace(/\s*is-open/, '');
      head.setAttribute('aria-expanded', 'false');
    } else {
      group.className += ' is-open';
      head.setAttribute('aria-expanded', 'true');
    }
  });
})();
